import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useGetRewardsInfo } from "queries/useGetRewardsInfo";
import { useGetLoyaltyRewardsUser } from "queries/useGetLoyaltyRewardsUser";
import { useGetProgressLoyalty } from "queries/useGetProgressLoyalty";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { currentCurrency } from "redux/user/selectors";
import { formatDataProgressLoyaltyRanks } from "utils/loyalty";
import LoyaltyListRanksMobile from "components/organisms/LoyaltyListRanksMobile";
import useTranslate from "hooks/useTranslate";
import { getIdsRewards } from "../../utils/loyalty-rewards";

export const LoyaltyListRanksMobileContainer = () => {
  const t = useTranslate();
  const { data: loyaltyUser } = useGetLoyaltyUser();
  const { data: progressUser } = useGetProgressLoyalty();
  const currencyCode = useSelector(currentCurrency);
  const loyalty = loyaltyUser?.data?.data;
  const { userRewards } = useGetLoyaltyRewardsUser({ loyaltyId: loyalty?.id });
  const {
    nominals,
    freeSpins,
    // boosters,
    cashbackDaily,
    cashbackWeekly,
    cashbackMonthly,
  } = getIdsRewards(loyalty, currencyCode);
  const { rewardsInfo } = useGetRewardsInfo([
    ...nominals,
    ...freeSpins,
    ...cashbackDaily,
    ...cashbackMonthly,
    ...cashbackWeekly,
  ]);
  const userExperience = progressUser?.data?.data?.experience || 0;

  const ranks = useMemo(
    () =>
      formatDataProgressLoyaltyRanks({
        t,
        loyalty,
        userExperience,
        userRewards,
        infoRewards: rewardsInfo,
        currencyCode,
      }),
    [loyalty, rewardsInfo, userExperience, userRewards, currencyCode, t],
  );

  return (
    <LoyaltyListRanksMobile userExperience={userExperience} ranks={ranks} />
  );
};
